import { Outlet } from 'react-router-dom';

/** Rota pública `/invite/:idPassbook` — sem autenticação, sem AppShell/sidebar. */
export function PublicInviteRouteLayout() {
  return (
    <div className="flex min-h-screen flex-col">
      <Outlet />
    </div>
  );
}
